import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import Icon from '@atlaskit/icon';
var iconContainerStyles = {
  small: xcss({
    width: '16px',
    height: '16px'
  }),
  medium: xcss({
    width: '24px',
    height: '24px'
  }),
  large: xcss({
    width: '40px',
    height: '40px'
  }),
  xlarge: xcss({
    width: '48px',
    height: '48px'
  })
};
var t25IconContainerStyles = {
  small: xcss({
    width: '16px',
    height: '16px'
  }),
  medium: xcss({
    width: '24px',
    height: '24px'
  }),
  large: xcss({
    width: '32px',
    height: '32px'
  }),
  //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
  xlarge: xcss({
    width: '32x',
    height: '32px'
  })
};
var iconStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
export function getLogoVersion(t25LogoComponent, LogoComponent) {
  return fg('platform-team25-app-icon-tiles') ? t25LogoComponent : LogoComponent;
}
export function get3PLogo(iconGlyph, iconLabel) {
  return fg('rovo_search_custom_icon_component') ? RovoLogoFromSVG(iconGlyph, iconLabel) : RovoLogoFromGlyph(iconGlyph, iconLabel);
}
export var SVGIcon = function SVGIcon(_ref) {
  var SVG = _ref.glyph,
    label = _ref.label,
    size = _ref.size;
  var useT25Styles = fg('platform-team25-app-icon-tiles');
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [useT25Styles ? t25IconContainerStyles[size] : iconContainerStyles[size], iconStyles],
    "aria-label": label
  }, /*#__PURE__*/React.createElement(SVG, null));
};
export var RovoLogoFromLogo = function RovoLogoFromLogo(LogoComponent) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref2) {
    var label = _ref2.label,
      testId = _ref2.testId;
    return /*#__PURE__*/React.createElement(LogoComponent, {
      label: label || defaultLabel,
      testId: testId,
      size: "small",
      appearance: "brand"
    });
  };
};
export var RovoLogoFromSVG = function RovoLogoFromSVG(glyph) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref3) {
    var _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? defaultLabel : _ref3$label;
    return /*#__PURE__*/React.createElement(SVGIcon, {
      label: label,
      glyph: glyph,
      size: "medium"
    });
  };
};
export var RovoLogoFromGlyph = function RovoLogoFromGlyph(glyph) {
  var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (_ref4) {
    var _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? defaultLabel : _ref4$label,
      testId = _ref4.testId;
    return /*#__PURE__*/React.createElement(Icon, {
      label: label,
      testId: testId,
      glyph: glyph,
      size: "medium"
    });
  };
};